import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { ReactiveFormsModule } from '@angular/forms';
import { RemitterDetailsComponent } from './remitter-details.component';
import { MatAutoCompleteHybridModule } from '@pg-app/shared/components/mat-autocomplete-hybrid/mat-autocomplete-hybrid.module';
import { SwiftCharacterMessageModule } from '@pg-app/shared/components/swift-character-message/swift-character-message.module';
import { MatSelectHybridModule } from '@nttp/mat-select-hybrid/mat-select-hybrid.module';

@NgModule({
    imports: [
      CommonModule,
      CoreMaterialModule,
      CoreUiModule,
      ReactiveFormsModule,
      MatAutoCompleteHybridModule,
      SwiftCharacterMessageModule,
      MatSelectHybridModule
    ],
    declarations: [
      RemitterDetailsComponent
    ],
    exports: [
      RemitterDetailsComponent
    ]
})
export class RemitterDetailsModule { }
